"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _textAreaInputModule = _interopRequireDefault(require("./textAreaInput.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextAreaInput = function TextAreaInput(props) {
  var id = props.id,
      onChange = props.onChange,
      value = props.value,
      name = props.name,
      disabled = props.disabled,
      required = props.required,
      rows = props.rows,
      isVertical = props.isVertical,
      onBlur = props.onBlur,
      autoComplete = props.autoComplete,
      placeholder = props.placeholder;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("textarea", {
    id: id ? id : null,
    rows: rows ? rows : 5,
    autoComplete: autoComplete ? autoComplete : "",
    className: (0, _classnames.default)(_themeModule.default.arag, _textAreaInputModule.default["form-control"], _textAreaInputModule.default["textarea-comp"], isVertical ? _textAreaInputModule.default["text-area-vertical"] : ""),
    value: value,
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    disabled: disabled,
    required: required,
    placeholder: placeholder
  }));
};

TextAreaInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** Callback invoked when the input changes.It will be passed with an event argument as an argument.eg: (evt) =>{} */
  onChange: _propTypes.default.func.isRequired,

  /** The name attribute of the element */
  name: _propTypes.default.string.isRequired,

  /** The value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /** Boolean indicating if the component is disabled  */
  disabled: _propTypes.default.bool,

  /** Boolean indicating if the text area in only vertical  */
  isVertical: _propTypes.default.bool,

  /** The rows of the text area */
  rows: _propTypes.default.number,

  /** String that specifies the placeholder of the input  */
  placeholder: _propTypes.default.string
};
var _default = TextAreaInput;
exports.default = _default;